import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import { 
	NavLink,
	Dropdown,
	DropdownItem,
	DropdownToggle,
	DropdownMenu,
} from 'reactstrap';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import './MenuLinks.scss';

function MenuLinks() {
	/* eslint-disable no-unused-vars */
	let onLoading;
	let showInfoMessage;
	let showSuccessMessage;
	let showWarningMessage;
	let showErrorMessage;
	/* eslint-enable no-unused-vars */

	const [dropdownOpen, setDropdownOpen] = useState(false);

	const toggle = () => setDropdownOpen(!dropdownOpen);

	return (
		<>
			<AlertasContext.Consumer>
				{alertas => {
					showInfoMessage = alertas.info;
					showSuccessMessage = alertas.success;
					showWarningMessage = alertas.warning;
					showErrorMessage = alertas.error;
				}}
			</AlertasContext.Consumer>
			<BlockUiContext.Consumer>
				{blockUi => {
					onLoading = blockUi.handleLoading;
				}}
			</BlockUiContext.Consumer>

			<Dropdown nav isOpen={dropdownOpen} toggle={toggle} className="dropdown">
				<DropdownToggle color="#193d5a" className="dropdown">
					<i className="fas fa-circle green" />
					Links Disponíveis
					<i className="fas fa-chevron-down chevron" />
				</DropdownToggle>
				<DropdownMenu className="list">
					<DropdownItem tag="div" className="links">
						<NavLink
							href="https://auditor.econeteditora.com.br/validar-login"
							className="itemList-first"
							target="_blank"
							rel="noopener noreferrer"
						>
							<i className="fas fa-external-link-alt external-link" />
							Para gerar a <b>GNRE por Apuração</b>, favor auditar o arquivo TXT através do <b>Auditor Fiscal</b>
						</NavLink>
						<NavLink
							href="https://www.gnre.pe.gov.br:444/gnre/portal/GNRE_DisponibilidadeUF.jsp"
							className="itemList"
							target="_blank"
							rel="noopener noreferrer"
						>
							<i className="fas fa-external-link-alt external-link" />
							Verificar disponibilidade de emissão por UF
						</NavLink>
						<NavLink
							href="https://www.gnre.pe.gov.br:444/gnre/portal/bancosArrecadadores.jsp"
							className="itemList-last"
							target="_blank"
							rel="noopener noreferrer"
						>
							<i className="fas fa-external-link-alt external-link" />
							Verificar disponibilidade de remessa bancária por UF
						</NavLink>
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		</>
	);
}

export default withRouter(MenuLinks);
